(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-kira-360"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-kira-viewer')) {
    customElements.define('hs-kira-viewer', class extends HTMLElement {
      static cards = new Set();
      static pending = false;
      static scheduleMobile() {
        const Class = customElements.get('hs-kira-viewer');
        if (Class.pending || !Class.cards.size) return;
        Class.pending = true;
        requestAnimationFrame(() => {
          Class.pending = false;
          const viewport = window.visualViewport;
          const top = viewport?.offsetTop || 0;
          const height = viewport?.height || window.innerHeight;
          const enabled = !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches && matchMedia('(max-width: 749px), (hover: none), (pointer: coarse)').matches && !document.querySelector('.hs-kira-dialog[open]');
          const candidates = enabled ? [...Class.cards].filter(item => item.isConnected).map(item => {
            const box = item.media.getBoundingClientRect();
            return { item, center: box.top + box.height / 2, box };
          }).filter(({center, box}) => box.width > 0 && box.height > 0 && center >= top + height / 6 && center <= top + height * 5 / 6 && box.right > 0 && box.left < window.innerWidth).sort((a, b) => Math.abs(a.center - top - height / 2) - Math.abs(b.center - top - height / 2)).slice(0, 2).map(entry => entry.item) : [];
          for (const item of Class.cards) {
            const active = candidates.includes(item);
            if (active) {
              item.mobileActive = true;
              if (!item.hoverHost && !item.hoverTimer) item.hoverTimer = setTimeout(() => {
                item.hoverTimer = null;
                if (item.mobileActive && item.isConnected) item.startPreview();
              }, 200);
            } else if (item.mobileActive) {
              item.mobileActive = false;
              item.stopHover();
            }
          }
        });
      }
      connectedCallback() {
        if (this.initialized) return;
        const valid = (raw, kind) => {
          try {
            const url = new URL(raw);
            if (url.protocol !== 'https:' || url.port || url.username || url.password || url.hash) return '';
            const viewer = kind === 'viewer';
            if (url.hostname !== (viewer ? 'dnaimages.s3.ap-south-1.amazonaws.com' : 'api.kiradiam.com')) return '';
            if (url.pathname !== (viewer ? '/videos/Vision360.html' : '/api/FTP/GetCertificateByReportNo')) return '';
            if (!/^\d+$/.test(url.searchParams.get(viewer ? 'd' : 'ReportNo') || '')) return '';
            return raw;
          } catch { return ''; }
        };
        const viewerUrl = valid(this.dataset.viewerUrl, 'viewer');
        const certificateUrl = valid(this.dataset.certificateUrl, 'certificate');
        const dialog = this.querySelector('dialog');
        if ((!viewerUrl && !certificateUrl) || !dialog || typeof dialog.showModal !== 'function') return;
        this.initialized = true;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.dialog = dialog;
        this.host = dialog.querySelector('.hs-kira-frame');
        const status = dialog.querySelector('.hs-kira-status');
        const help = dialog.querySelector('.hs-kira-help span');
        const fallback = dialog.querySelector('a');
        const open = this.querySelector('.hs-kira-open');
        const certificate = this.querySelector('.hs-kira-certificate');
        document.body.append(dialog);
        this.makeFrame = (url, isCertificate) => {
          const frame = document.createElement('iframe');
          frame.title = isCertificate ? 'Original diamond grading certificate PDF' : 'Interactive 360 degree diamond viewer';
          frame.referrerPolicy = 'no-referrer';
          frame.setAttribute('allow', "autoplay 'none'; camera 'none'; microphone 'none'");
          if (!isCertificate) frame.setAttribute('sandbox', 'allow-scripts allow-same-origin');
          frame.src = url;
          return frame;
        };
        const launch = (event, url, isCertificate) => {
          event.preventDefault();
          event.stopPropagation();
          for (const item of customElements.get('hs-kira-viewer').cards) { item.mobileActive = false; item.stopHover(); }
          this.stopHover();
          this.returnFocus = event.currentTarget;
          dialog.dataset.media = isCertificate ? 'certificate' : 'viewer';
          dialog.querySelector('h2').textContent = isCertificate ? certificate.innerText.split('\n')[0] : 'Diamond 360° view';
          status.hidden = false;
          status.textContent = isCertificate ? 'Loading original certificate…' : 'Loading diamond viewer…';
          help.textContent = isCertificate ? 'If the PDF is not displayed, use the original certificate link.' : 'Drag the diamond to explore. If it is not displayed, use the supplier link.';
          fallback.textContent = isCertificate ? 'Open original certificate (PDF)' : 'Open supplier viewer in a new tab';
          fallback.href = url;
          dialog.showModal();
          const frame = this.makeFrame(url, isCertificate);
          frame.addEventListener('load', () => {
            clearTimeout(this.timer);
            status.textContent = isCertificate ? 'Original supplier certificate (PDF).' : 'Supplier viewer opened. The diamond may take a moment to appear.';
          }, { once: true });
          frame.addEventListener('error', () => {
            clearTimeout(this.timer);
            this.host.replaceChildren();
            status.textContent = 'The embedded media could not load. Please use the original media link below.';
          }, { once: true });
          this.timer = setTimeout(() => {
            this.host.replaceChildren();
            status.textContent = 'The media is taking too long to load. Please use the original media link below.';
          }, 20000);
          this.host.replaceChildren(frame);
        };
        if (viewerUrl) {
          open.hidden = false;
          open.addEventListener('click', event => launch(event, viewerUrl, false), options);
        }
        if (certificate && certificateUrl) {
          certificate.hidden = false;
          certificate.href = certificateUrl;
          certificate.setAttribute('aria-label', 'Open original diamond certificate PDF in a new tab');
        }
        dialog.querySelector('.hs-kira-close').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('close', () => {
          clearTimeout(this.timer);
          this.host.replaceChildren();
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
          customElements.get('hs-kira-viewer').scheduleMobile();
        }, options);
        if (this.hasAttribute('data-card-mode') && viewerUrl) {
          const card = this.closest('.card-wrapper');
          const media = this.closest('.card__inner');
          const motion = matchMedia('(prefers-reduced-motion: reduce)');
          const hover = matchMedia('(hover: hover) and (pointer: fine)');
          this.startPreview = () => {
            if (this.hoverHost) return;
                this.hoverHost = document.createElement('div');
                this.hoverHost.className = 'hs-kira-hover';
                this.hoverHost.setAttribute('aria-hidden', 'true');
                const frame = this.makeFrame(viewerUrl, false);
                frame.tabIndex = -1;
                frame.addEventListener('load', () => { frame.dataset.loaded = ''; }, { once: true });
                frame.addEventListener('error', () => this.stopHover(), { once: true });
                this.hoverHost.append(frame);
                this.prepend(this.hoverHost);
          };
          if (media) {
            this.media = media;
            const Class = customElements.get('hs-kira-viewer');
            Class.cards.add(this);
            Class.scheduleMobile();
          }
          if (card && media) {
            card.addEventListener('pointermove', event => {
              if (event.pointerType !== 'mouse' || !hover.matches || this.mobileActive) return;
              const box = media.getBoundingClientRect();
              const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
              if (!inside || event.pointerType !== 'mouse' || !hover.matches || motion.matches || dialog.open) { this.stopHover(); return; }
              if (this.hoverTimer || this.hoverHost) return;
              this.hoverTimer = setTimeout(() => {
                this.hoverTimer = null;
                const Class = customElements.get('hs-kira-viewer');
                Class.activeHover?.stopHover();
                Class.activeHover = this;
                this.startPreview();
              }, 400);
            }, options);
            card.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !this.mobileActive) this.stopHover(); }, options);
            document.addEventListener('visibilitychange', () => { if (document.hidden) this.stopHover(); }, options);
          }
        }
        this.hidden = false;
      }
      stopHover() {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
        this.hoverHost?.remove();
        this.hoverHost = null;
      }
      disconnectedCallback() {
        const Class = customElements.get('hs-kira-viewer');
        Class.cards.delete(this);
        this.mobileActive = false;
        this.events?.abort();
        clearTimeout(this.timer);
        this.stopHover();
        if (this.dialog) {
          if (this.dialog.open) this.dialog.close();
          this.host?.replaceChildren();
          this.append(this.dialog);
        }
        this.initialized = false;
      }
    });
    const schedule = () => customElements.get('hs-kira-viewer').scheduleMobile();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', schedule);
    matchMedia('(max-width: 749px), (hover: none), (pointer: coarse)').addEventListener('change', schedule);
  }
  } catch(e) { console.error(e); }
})();

})();
